import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const useTitles = () => {
  const { user } = useAuth();
  
  const dynamicHook = useDynamicEntity({
    entityType: 'titles',
    gqlEntityKey: 'titles',
    queryName: 'GET_TITLES_QUERY',
    createMutation: 'CREATE_TITLE_MUTATION',
    updateMutation: 'UPDATE_TITLE_MUTATION',
    deleteMutation: 'DELETE_TITLE_MUTATION',
    transformData: (title) => ({
      ...title,
      company_name: title.company?.name || `Company ${title.company_id}`,
      name: title.title_name,
      code: title.title_code,
      description: title.title_description,
      status: title.title_status ? 'active' : 'inactive',
      companyId: title.company_id,
    }),
    transformFormData: (formData) => ({
      title_name: formData.name,
      title_code: formData.code,
      title_description: formData.description || null,
      title_status: formData.status === 'active',
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });

  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useTitles };
